import Logo from "../../src/Logo/A1LogoNoBackgroud.png";
import "./Header.css";
import { FaBars, FaTimes, FaThLarge } from "react-icons/fa";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../Firebase";
import logger from "../Components/Logger";

export function Header({ language, setLanguage, t, isConnected, setConnected }) {
  //exemple de code pour tout ce qui est relier au (hamburger) prit sur : https://www.codeconcisely.com/posts/nextjs-route-change-hide-component/
  const [isOpen, setIsOpen] = useState(false);
  const [pricingOpen, setPricingOpen] = useState(false);
  const [isLoginOpen,setIsLoginOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const pricingCurrent = pathname === "/groupPricing" || pathname === "/individualPricing";

  const handleAction = async () => {
    logger.info("Handling action in header");
  if (isConnected) {
    try {
      await signOut(auth);
      setConnected(false);
      setIsLoginOpen(false);
      navigate("/admin-login");
      logger.info("User signed out successfully, navigating to admin login page");
    } catch (error) {
      console.log(error);
      logger.error("Error occurred while signing out");
    }
  } else {
    setIsLoginOpen(false);
    navigate("/admin-login");
    logger.info("Navigating to admin login page");
  }
  };
  const closeMenu = () => {
    setIsOpen(false);
    setPricingOpen(false);
  };

  const goToDashboard = () => {
    navigate("/admin");
    setIsLoginOpen(false);
    logger.info("Navigating to admin dashboard");
  };

  return (
    <header className="header">
      <NavLink to="/" onClick={closeMenu}>
        <div className="logo-container">
          <img src={Logo} alt="A1 Tutorial Logo" className="logo" />
        </div>
      </NavLink>

      <div
        className={`menu-icon ${isOpen ? "is-open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        role="button"
        aria-expanded={isOpen}
        aria-label="Menu"
      >
        {isOpen ? <FaTimes /> : <FaBars />}
      </div>

      <nav className={`nav-links ${isOpen ? "active" : ""}`}>{/*Exemple trouver sur :https://www.codeconcisely.com/posts/nextjs-route-change-hide-component/ */}
        <NavLink to="/" end onClick={closeMenu}>{t.Home}</NavLink>
        <NavLink to="/aboutus" onClick={closeMenu}>{t.AboutUs}</NavLink>{/*permet que quand on clique sur le lien , le menu se ferme*/ }
        <NavLink to="/courses" onClick={closeMenu}>{t.Courses}</NavLink>
        <NavLink to="/contact" onClick={closeMenu}>{t.Contact}</NavLink>

        <div className={`navItem ${pricingCurrent ? "is-current" : ""} ${pricingOpen ? "is-open" : ""}`}>
          <button
            type="button"
            className="nav-label"
            aria-expanded={pricingOpen}
            onClick={() => setPricingOpen((open) => !open)}
          >
            {t.PricingSchedule}
            <span className="nav-caret" aria-hidden="true">▼</span>
          </button>
          <div className="dropdownMenu">
            <NavLink to="/groupPricing" onClick={closeMenu}>{t.GroupTutoring}</NavLink>
            <NavLink to="/individualPricing" onClick={closeMenu}>{t.IndividualTutoring}</NavLink>
          </div>
        </div>

        <NavLink to="/admission" onClick={closeMenu}>{t.Admission}</NavLink>
      </nav>

      <div className="header-right">
        <div id="google_translate_element" />

        {/* Source : Corriger par ChatGPT */}
        <div className="login-menu">
          <button
            className={`login-profile-btn ${isConnected ? "is-connected" : ""}`}
            onClick={() => setIsLoginOpen(!isLoginOpen)}
            aria-label={isConnected ? "Admin account" : "Admin sign in"}
          >
            <span className="login-avatar" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <circle cx="12" cy="8" r="3.2" />
                <path d="M5.6 18.6c.9-3.1 3.3-4.6 6.4-4.6s5.5 1.5 6.4 4.6" />
              </svg>
            </span>

            <div className="login-text">
              <h4><span>Admin</span></h4>
              <p>{isConnected ? "Administrator" : "Not connected"}</p>
            </div>
          </button>

          {isLoginOpen && (
            <div className="login-dropdown">
              {isConnected && (
              <button onClick={goToDashboard} className="login-dropdown-btn">
                <FaThLarge/>
                <span>Dashboard</span>
              </button>
            )}

              <button onClick={handleAction} className={`login-dropdown-btn ${isConnected ? "logout-active" : ""}`}>
                <span>{isConnected ? "Sign Out" : "Sign In"}</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
